const CheckIcon = ({ fill, className }) => {
  return (
    <svg
      className={className}
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12_1693)">
        <path
          d="M18.0447 6.70557C18.4842 7.14502 18.4842 7.85869 18.0447 8.29814L9.04473 17.2981C8.60527 17.7376 7.8916 17.7376 7.45215 17.2981L2.95215 12.7981C2.5127 12.3587 2.5127 11.645 2.95215 11.2056C3.3916 10.7661 4.10527 10.7661 4.54473 11.2056L8.2502 14.9075L16.4557 6.70557C16.8951 6.26611 17.6088 6.26611 18.0482 6.70557H18.0447Z"
          fill={fill || "#FF0000"}
        />
      </g>
      <defs>
        <clipPath id="clip0_12_1693">
          <path d="M2.625 3H18.375V21H2.625V3Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
